const hourReg = new RegExp('^[0-2]?[0-9]:[0-5][0-9]$');
export const dateReg = new RegExp(
  /^([0]?[1-9]|[1-2]?[0-9]|[3][0-1])\/([0]?[1-9]|[1][0-2])\/([0-9]{2}|[0-9]{4})$/,
);
export const dateReg2 = new RegExp(
  /^([0-9]{2}|[0-9]{4})-([0]?[1-9]|[1][0-2])-([0]?[1-9]|[1-2]?[0-9]|[3][0-1])$/,
);
const numberReg = new RegExp('^[0-9]+$');
const floatReg = new RegExp('^[0-9]+([.][0-9][0-9]?)?$');
const stringReg = new RegExp(/^[\w\s\u00C0-\u00FF,.]*$/);
const emailReg = new RegExp(/^\S+@\S+\.\S+$/);
const concreteCommonReg =
  '[H][A]-(20|25|30|35|40|45|50|55|60|70|80|90|100)/[SPBFL]/(8|12|16|20|40)/';

const EHEReg = new RegExp(
  '^' +
    '(?!\\s)' +
    concreteCommonReg +
    '(I|IIa|IIb|IIIa|IIIb|IIIc|IV)(.*)?' +
    '(?<!\\s)' +
    '$',
);

const CEReg = new RegExp(
  '^' +
    '(?!\\s)' +
    concreteCommonReg +
    'X(0|C1|C2|C3|C4|S1|S2|S3|D1|D2|D3)(.*)?' +
    '(?<!\\s)' +
    '$',
);

const plateReg = new RegExp(/^[0-9][0-9][0-9][0-9][-]?[A-Z][A-Z][A-Z]$/);
const cifReg = new RegExp(
  /^([0-9]{8}[-]?[A-Z]|[A-Z][-]?[0-9]{8}|[A-Z][-]?[0-9]{7}[-]?[A-Z]){1}$/,
);

const plantReg = new RegExp(/^\S(?:.*\S)?$/);

const REGEXP = {
  hour: hourReg,
  date: dateReg,
  integer: numberReg,
  float: floatReg,
  string: stringReg,
  email: emailReg,
  phone: numberReg,
  EHE: EHEReg,
  CE: CEReg,
  plate: plateReg,
  cif: cifReg,
  plant: plantReg,
  //concrete_id: cementReg,
};

const ruleTransformer = (formItem) => {
  switch (formItem.rules?.type) {
    case 'boolean':
      if (formItem.value === '' || formItem.value === null) return null;
      return formItem.value;
    case 'float':
    case 'integer':
      if (formItem.value === '' || formItem.value === null) return null;
      else return Number(String(formItem.value).replace(',', '.'));
    case 'date':
      return formItem.value;
    case 'hour':
      let hourString = String(formItem.value);
      if (hourString.length > 4) return hourString;
      return hourString + ':00';
    case 'compressive_strength':
      let csObject = {
        strength_extra: {},
      };
      const classicDays = [3, 7, 28, 60];
      const parser = ({ day, value1, value2, value3 }) => {
        return {
          [`compressive_strength_${day}_1`]: Number.parseFloat(value1) || null,
          [`compressive_strength_${day}_2`]: Number.parseFloat(value2) || null,
          [`compressive_strength_${day}_3`]: Number.parseFloat(value3) || null,
        };
      };
      formItem.value.forEach((element) => {
        if (classicDays.includes(Number.parseInt(element.day))) {
          csObject = { ...csObject, ...parser(element) };
        } else {
          csObject.strength_extra = {
            ...csObject.strength_extra,
            ...parser(element),
          };
        }
      });
      return csObject;
    default:
      if (!formItem.value) return undefined;
      return String(formItem.value);
  }
};

const checkRules = (value, rules, customValidation) => {
  try {
    const errors = [];
    if (!value) {
      if (rules.required) {
        errors.push([{ id: 'required' }, {}]);
      }
    } else {
      if (rules.type && rules.type !== 'fullString') {
        if (!REGEXP[rules.type].test(String(value))) {
          errors.push([{ id: customValidation || rules.type }, {}]);
        }
      }
      if (rules.maxLength) {
        if (String(value).length > rules.maxLength)
          errors.push([{ id: 'maxLength' }, { max: rules.maxLength }]);
      }
      if (rules.equalLength) {
        if (String(value).length !== rules.equalLength)
          errors.push([{ id: 'equalLength' }, { equal: rules.equalLength }]);
      }
      if (rules.minValue) {
        if (Number(value) < rules.minValue)
          errors.push([{ id: 'minValue' }, { min: rules.minValue }]);
      }
      if (rules.maxValue) {
        if (Number(value) > rules.maxValue)
          errors.push([{ id: 'maxValue' }, { max: rules.maxValue }]);
      }
    }
    return errors;
  } catch (error) {
    return [];
  }
};
function subFormIsValidated(object, array) {
  for (const element of array) if (object[element].length > 0) return false;

  return true;
}

function formIsValidated(object) {
  for (const i in object) if (object[i].status.length > 0) return false;
  return true;
}

function allAttrAreTrue(object) {
  for (const i in object) {
    if (object[i] === false) return false;
  }
  return true;
}

function regionsAreVisibled(regions) {
  for (const index in regions) {
    if (regions[index].isVisible === false) return false;
  }
  return true;
}
export {
  checkRules,
  formIsValidated,
  ruleTransformer,
  allAttrAreTrue,
  subFormIsValidated,
  regionsAreVisibled,
};
